// Centralized scroll helpers for the SPA screen system.
// Use these when changing screens or when re-clicking the same tab (Inventory/Reports/etc)
// to avoid opening pages from a preserved mid-scroll position.

export const scrollToTop = () => {
  if (typeof window === 'undefined') return;

  const html = document.documentElement;
  const body = document.body;

  // Temporarily disable smooth scrolling for an immediate reset.
  const prevHtmlBehavior = html?.style?.scrollBehavior;
  const prevBodyBehavior = body?.style?.scrollBehavior;

  if (html?.style) html.style.scrollBehavior = 'auto';
  if (body?.style) body.style.scrollBehavior = 'auto';

  try {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  } catch {
    window.scrollTo(0, 0);
  }

  if (html) html.scrollTop = 0;
  if (body) body.scrollTop = 0;

  const appMain = document.querySelector('.app-main');
  if (appMain) appMain.scrollTop = 0;

  // Restore previous scroll behavior next frame.
  requestAnimationFrame(() => {
    if (html?.style) html.style.scrollBehavior = prevHtmlBehavior || '';
    if (body?.style) body.style.scrollBehavior = prevBodyBehavior || '';
  });
};
